var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useState } from 'react';
/**
 * Custom hook to set the latest order details in a cache.
 * This hook updates a singleton object and the global window object
 * If you wish to persist the OD data across different pages move to localStorage
 * or a session storage solution.
 */
export function useSetOrderDetailsCache(_a) {
    var data = _a.data, error = _a.error, loaded = _a.loaded;
    // Define the state for the order details cache
    var _b = useState({
        data: undefined,
        error: undefined,
        loaded: false,
    }), orderDetailsCacheState = _b[0], setOrderDetailsCacheState = _b[1];
    // Update the cache state whenever the data, error, or loaded state changes
    useEffect(function () {
        setOrderDetailsCacheState({
            data: data,
            error: error,
            loaded: !!loaded,
        });
    }, [data, error, loaded]);
    // Store the cache state in a global object (window) for easy access
    if (typeof window !== 'undefined') {
        window.orderDetailsCache = __assign({}, orderDetailsCacheState);
    }
    // Cleanup function to reset the cache state when the component unmounts
    useEffect(function () {
        return function () {
            setOrderDetailsCacheState({
                data: undefined,
                error: undefined,
                loaded: false,
            });
            if (typeof window !== 'undefined') {
                delete window.orderDetailsCache;
            }
        };
    }, []);
    // Expose the cache state to the global window object
    // Always return the latest state
    return __assign({}, orderDetailsCacheState);
}
